import React from "react";
import { useAtom } from "jotai";
import { DarkModeState } from "../../Jotai/index";
import { Icon } from '@iconify/react';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "../../style/Advertisements/index.scss";

const advertisementsData = [
   
  // {
  //   title: "Beach Bash",
  //   link: "https://www.asicsulb.org/corporate/enjoy/event-calendar/9322", 
  //   desktop: "/image/Advertisements/SP25_BPE_BeachBash-BeachFront-desktop.jpg",
  //   mobile: ["/image/Advertisements/SP25_BPE_BeachBash-promo-mobile.jpg"]
  // },
  {
    title: "FUTUREU",
    link: "https://asicsulb.org/corporate/discover/futureu",
    desktop: [
      "/image/Advertisements/SP25_USU_FUTUREU_AD-9x11in_22-West-Web-Ad-Desktop-1.png",
      "/image/Advertisements/SP25_USU_FUTUREU_AD-9x11in_22-West-Web-Ad-Desktop-2.png",
    ],
    mobile: [
      "/image/Advertisements/SP25_USU_FUTUREU_AD-9x11in_22-West-Web-Ad-Mobile.jpg",
    ]
  },
];


const Advertisements = () => {
  const [darkMode] = useAtom(DarkModeState);

  return (
    <div className="Advertisements relative">
      <div className={darkMode ? "AdvertisementsMain darkmode" : "AdvertisementsMain"}>
        <div className="Advertisements_title">Advertisements</div>

        <div className="AdvertisementsCarouselWrapper ">
          <Carousel
            autoPlay
            interval={4000}
            infiniteLoop
            showThumbs={false}
            showStatus={false}
            showArrows={true}
            showIndicators={false} // Hide indicators if single add
            emulateTouch
            renderArrowPrev={(onClickHandler, hasPrev, label) =>
              hasPrev && (
                <div
                  className={`z-[2] absolute left-2 top-[47%] -translate-y-1/2 ${darkMode?'bg-[#262626]':'bg-[#ffff]'} rounded-full w-10 h-10 transition duration-200 active:scale-95 hover:scale-105 transform hidden md:flex items-center justify-center cursor-pointer shadow-lg`}
                  onClick={onClickHandler}
                  title={label}
                >
                  <Icon
                    icon="oui:arrow-left"
                    className={`text-lg ${darkMode?'text-white':'text-black'} font-bold`}
                  />
                </div>
              )
            }
            renderArrowNext={(onClickHandler, hasNext, label) =>
              hasNext && (
                <div
                  className={`z-[2] absolute right-2 top-[47%] -translate-y-1/2 ${darkMode?'bg-[#262626]':'bg-[#ffff]'}  rounded-full w-10 h-10 transition duration-200 active:scale-95 hover:scale-105 transform hidden md:flex items-center justify-center cursor-pointer shadow-lg`}
                  onClick={onClickHandler}
                  title={label}
                >
                  <Icon
                    icon="oui:arrow-right"
                    className={`text-lg ${darkMode?'text-white':'text-black'} font-bold`}
                  />
                </div>
              )
            }
          >
            {advertisementsData.map((ad, idx) => (
              <div key={idx}>
                <a href={ad.link} target="_blank" rel="noopener noreferrer">
                  {/* Desktop image */}
                  {/* <div className="hidden lg:block"> */}
                  <div className="hidden lg:flex flex-row justify-center align-center">
                    {ad.desktop.map((src, i) => (
                      <img
                        key={i}
                        src={src}
                        alt={`${ad.title} Desktop ${i + 1}`}
                        className="h-auto w-auto object-cover"
                      />
                    ))}
                  </div>
                  {/* Mobile images */}
                  {/* <div className="flex lg:hidden flex-col gap-2"> */}
                  <div className="flex-1 flex lg:hidden flex-col justify-between gap-5">
                    {ad.mobile.map((src, i) => (
                      <img
                        key={i}
                        src={src}
                        alt={`${ad.title} Mobile ${i + 1}`}
                        className="AdvertisementsImgData w-full object-contain"
                      />
                    ))}
                  </div>
                </a>
              </div>
            ))}
          </Carousel>
        </div>
      </div>
    </div>
  );
};

export default Advertisements;
